<template>
  <v-card>
    <v-card-title>
      <span class="headline">{{ title }}</span>
    </v-card-title>
    <v-card-text class="ma-0 pa-0" style="color:black">
      <v-form ref="form" lazy-validation>
        <v-container>
          <v-row>
            <v-col cols="12">
              <v-label><u>Title</u></v-label>
              <v-text-field
                outlined
                :rules="[v => !!v || 'Title name is required']"
                :value="initialName"
                v-on:input="editedName = $event"
                placeholder="An Opportunity"
              ></v-text-field>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="12">
              <v-label><u>Description</u></v-label>
              <vue-editor
                placeholder="* Description 
* Who is this for 
* Documents required to apply"
                :value="initialText"
                v-on:input="editedText = $event"
                :editorToolbar="customToolbar"
              ></vue-editor>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="12">
              <v-label class="headline">
                <u>
                Applications on Sponsors portal
                </u>
              </v-label>
              <br />
              <v-label>
                When Enabled, members can apply to this opportunity directly
                through our portal (this is a much easier process for our
                members)
                <strong>(Remember to check back and see who applied)</strong>
              </v-label>
              <br />
              <v-label>
                When Disabled, members will be shown the link you will provide
                below, to apply
              </v-label>
              <v-switch
                v-model="applyOnPortalEdit"
                color="success"
                :label="`${applyOnPortalText}`"
              ></v-switch>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="12" class="mt-n5">
              <div v-if="!applyOnPortalEdit">
                <v-label>Link to your application page: </v-label>
                <v-text-field
                  v-model="applyLinkEdit"
                  outlined
                  :rules="[
                    v =>
                      validURL(v) ||
                      applyOnPortalEdit ||
                      'URL not correct format (remember to add https://)'
                  ]"
                  placeholder="https://example.com/apply"
                ></v-text-field>
              </div>
            </v-col>
          </v-row>
        </v-container>
      </v-form>
    </v-card-text>
    <v-card-actions>
      <v-spacer></v-spacer>
      <v-btn color="blue darken-1" text @click="close">Hide</v-btn>
      <v-btn color="blue darken-1" text @click="checkSync()">Publish</v-btn>
    </v-card-actions>
  </v-card>
</template> 

<script>
import { VueEditor } from "vue2-editor";

export default {
  props: [
    "title",
    "name",
    "text",
    "sync",
    "close",
    "applyOnPortal",
    "applyLink"
  ],
  components: {
    VueEditor
  },
  data: function() {
    return {
      editedText: "",
      editedName: this.name,
      applyOnPortalEdit: this.applyOnPortal,
      applyLinkEdit: this.applyLink,
      customToolbar: [
        [{ header: [false, 1, 2, 3, 4, 5, 6] }],
        ["bold", "italic", "underline", "strike"],
        [{ list: "ordered" }, { list: "bullet" }],
        [{ script: "sub" }, { script: "super" }],
        [{ color: [] }, { background: [] }],
        ["link"],
        ["clean"]
      ]
    };
  },
  methods: {
    checkSync() {
      if (this.$refs.form.validate()) {
        this.sync(
          this.editedName,
          this.editedText,
          this.applyOnPortalEdit,
          this.applyLinkEdit
        );
      }
    },
    validURL(str) {
      var pattern = new RegExp(
        "^(https?:\\/\\/)" + // protocol
        "((([a-z\\d]([a-z\\d-]*[a-z\\d])*)\\.)+[a-z]{2,}|" + // domain name
        "((\\d{1,3}\\.){3}\\d{1,3}))" + // OR ip (v4) address
        "(\\:\\d+)?(\\/[-a-z\\d%_.~+]*)*" + // port and path
        "(\\?[;&a-z\\d%_.~+=-]*)?" + // query string
          "(\\#[-a-z\\d_]*)?$",
        "i"
      ); // fragment locator
      return !!pattern.test(str);
    }
  },
  computed: {
    initialName() {
      return this.name;
    },
    initialText() {
      return this.text;
    },
    applyOnPortalText() {
      if (this.applyOnPortalEdit) {
        return "Enabled";
      } else {
        return "Disabled";
      }
    }
  }
};
</script>